if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.intersectionObserver = null;
      this.mutationObserver = null;
    }

    connectedCallback() {
      if (FoxTheme.config.motionReduced) return;

      this.promotion = this.querySelector('.promotion');
      if (!this.promotion) return;

      this.removeInjectedPreorderBadges();
      this.init();
      this.watchForInjectedPreorderBadges();
    }

    init() {
      if (!this.promotion) return;

      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          const clone = this.promotion.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
          this.appendChild(clone);
        }
      }

      if (!this.intersectionObserver) {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        this.intersectionObserver.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }

    watchForInjectedPreorderBadges() {
      if (this.mutationObserver) return;

      this.mutationObserver = new MutationObserver(() => {
        this.removeInjectedPreorderBadges();
      });

      this.mutationObserver.observe(this, { childList: true, subtree: true });
    }

    removeInjectedPreorderBadges() {
      this.querySelectorAll('.hs-po-item-badge').forEach((badge) => {
        const previousSibling = badge.previousSibling;
        if (previousSibling && previousSibling.nodeName === 'BR') {
          previousSibling.remove();
        }
        badge.remove();
      });
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
